<div class="row g-4">
  <div class="col-12 col-xl-5">
    <div class="h-100">
      <label class="form-label fw-semibold text-black">Template</label>
      <select
        :value="selected_template_id"
        class="form-select form-select-lg rounded-4 mb-3"
        :disabled="loading || !template_bindings.length"
        @change="on_template_change"
      >
        <option value="">{{ loading ? 'Loading templates...' : 'Select a template' }}</option>
        <option
          v-for="template in template_bindings"
          :key="template.id"
          :value="String(template.id)"
        >
          {{ template.name }}
        </option>
      </select>

      <p class="text-muted mb-4">
        The template you pick drives the document preview and the recipient setup for this signing request.
      </p>

      <div v-if="load_error" class="alert alert-warning border rounded-4 mb-3">
        {{ load_error }}
      </div>

      <div v-else-if="selected_template" class="alert border rounded-4 bg-light mb-0">
        <div class="d-flex align-items-start gap-3">
          <i class="bi bi-info-circle-fill text-dark mt-1"></i>
          <div>
            <div class="fw-bold text-black">Selected template</div>
            <div class="text-muted">
              {{ selected_template.name }}
              <span v-if="selected_template.type" class="fw-semibold">({{ selected_template.type }})</span>.
              The recipient step will now use this template context.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 col-xl-7">
    <section class="border rounded-4 h-100">
      <div class="px-4 pt-3 pb-2">
        <div class="text-uppercase text-muted fw-semibold small">Preview</div>
      </div>

      <div class="px-3 pb-3">
        <div class="border rounded-4 overflow-hidden bg-light-subtle">
          <div class="border-bottom bg-white px-3 py-3">
            <div class="d-flex align-items-center justify-content-between gap-3 flex-wrap">
              <div class="d-flex align-items-center gap-2 min-w-0">
                <i class="bi bi-file-earmark-text text-muted"></i>
                <span class="text-black">{{ selected_template_name || 'Select a template to preview' }}</span>
              </div>
              <span v-if="selected_template" class="text-muted small">{{ selected_template_type_label }}</span>
            </div>
          </div>

          <div v-if="selected_template">
            <div class="p-3 p-lg-4">
              <div v-if="selected_template_url" class="document-preview-frame border bg-white rounded-3 overflow-hidden">
                <iframe
                  :key="selected_template_url"
                  :src="selected_template_url"
                  class="document-preview-iframe w-100"
                  frameborder="0"
                  title="Selected template preview"
                ></iframe>
              </div>
              <div v-else class="document-preview-empty-state border bg-white rounded-3 mx-auto p-4 d-flex flex-column align-items-center justify-content-center text-center">
                <i class="bi bi-file-earmark-x text-muted mb-3"></i>
                <div class="h6 text-black mb-2">No preview URL available</div>
                <div class="text-muted">This template was selected, but no previewable document link was returned.</div>
              </div>
            </div>
          </div>

          <div v-else class="document-preview-placeholder d-flex flex-column align-items-center justify-content-center text-center p-4">
            <i class="bi bi-file-earmark-lock2 text-muted mb-3"></i>
            <div class="h6 text-black mb-2">Select a template to preview</div>
            <div class="text-muted">The source document preview appears here once a valid template is selected.</div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <div class="col-12">
    <div class="d-flex align-items-center justify-content-end gap-2">
      <button
        type="button"
        class="btn onboarding-bg-navy-dark text-white fw-semibold px-4"
        :disabled="!selected_template"
        @click="$emit('continue')"
      >
        Continue
      </button>
    </div>
  </div>
</div>
